import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared-module/shared-module.module';
import { InventoryRoutingModule } from './inventory-routing.module';
import { InventoryDashboardComponent } from './inventory-dashboard/inventory-dashboard.component';
import { InventoryService } from './inventory.service';
import { EditDialogComponent } from './edit-dialog/edit-dialog.component';
import { InvItemsComponent } from './inv-items/inv-items.component';
import { CreateDrugDialogComponent } from './create-drug-dialog/create-drug-dialog.component';
import { ConsumeDialogComponent } from './consume-dialog/consume-dialog.component';
import { EditThreshholdComponent } from './edit-threshhold/edit-threshhold.component';



@NgModule({
  declarations: [
    InventoryDashboardComponent,
    EditDialogComponent,
    InvItemsComponent,
    CreateDrugDialogComponent,
    ConsumeDialogComponent,
    EditThreshholdComponent
  ],
  imports: [
    SharedModule,
    InventoryRoutingModule
  ],
  providers: [
    InventoryService
  ],
  entryComponents: [
    EditDialogComponent,
    CreateDrugDialogComponent,
    ConsumeDialogComponent,
    EditThreshholdComponent
  ]
})
export class InventoryModule { }
